import React from 'react';
import styles from './PaymentMethods.module.scss';

/* Components */
import { PaymentSelector } from '../PaymentSelector/PaymentSelector';
import { PaymentInfoContainer } from '../PaymentInfo/PaymentInfoContainer';
import { ButtonContainer } from '../ButtonContainer/ButtonContainer';
import { CouponUnlockableMessage } from '../CouponUnlockableMessage/CouponUnlockableMessage';
import { PromoCodeInput } from '../PromoCodeInput/PromoCodeInput';

/* Types */
import { StoreType } from '../../interfaces/store_types';
import { Product } from '../../interfaces/Product';

/* Providers */
import { PaymentProvider } from '../../__providers__/PaymentProvider';
import { BuyerProviderConnected } from '../../__providers__/BuyerProvider';
import { LoadingProvider } from '../../__providers__/LoadingProvider';
import { StoreProvider } from '../../__providers__/StoreProvider';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { PromoCodeProvider } from '../../__providers__/PromoCodeProvider';

/* Constants */
import { PAYPAL_KEY } from '../../../../constants/payments';

interface PaymentMethodsProps {
  store: StoreType;
  product: Product;
}

export const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  store,
  product,
}) => {
  return (
    <LoadingProvider>
      {/* <PromoCodeProvider> */}
      <PayPalScriptProvider
        options={{
          'client-id': PAYPAL_KEY,
          currency: product.price.currency,
          'disable-funding': 'credit,card,sofort',
          intent: 'capture',
        }}
      >
        <StoreProvider store={store}>
          <BuyerProviderConnected>
            <PaymentProvider>
              <div className={styles.container}>
                {product.unlockable ? (
                  <CouponUnlockableMessage />
                ) : (
                  <>
                    <PaymentSelector>
                      <PaymentInfoContainer />
                    </PaymentSelector>
                  </>
                )}
              </div>

              {/* <PromoCodeInput product={product} /> */}

              <ButtonContainer />
            </PaymentProvider>
          </BuyerProviderConnected>
        </StoreProvider>
      </PayPalScriptProvider>
      {/* </PromoCodeProvider> */}
    </LoadingProvider>
  );
};
